module.exports = __webpack_public_path__ + "static/media/sssaw.aa19c6e3.avif";